import React from 'react'
import workTimeline from '../../../js/homepage/workTimeline'

const WorkExperienceCard = () => {
  return (
      <section id="WorkExperienceCard">
        {workTimeline.map((work) => (
          <div className="workexperiencecard-wrap">
            <div className="workexp-topwrap">
              <div className="workexp-img">
                <img src={work.logo} alt="" />
              </div>
              <div className="workexp-detail">
                <h1>{work.title}</h1>
                <h2>{work.location}</h2>
                <h3>{work.date}</h3>
              </div>
            </div>
            <p>{work.description}</p>
          </div>
        ))}
      </section>
  )
}

export default WorkExperienceCard